// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Wx62k","filled":"Button_filled__CFvy-","transparent":"Button_transparent__kVJUC","red":"Button_red__0UDQY"};